export default __webpack_public_path__ + "static/media/cross-border.6bfb6beb.svg";